export const FieldTypeEnum = {
  SIGNATURE: "Signature",
  TEXT: "Text",
  DATE: "Date",
  CHECKBOX: "Checkbox",
  EMAIL: "Email",
  PICKLIST: "PickList",
};
